import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from "@angular/core";
import { OrderService } from "../../../order.service";
import { BaseFormComponent } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/base-form.component";
import { SelectorService } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/selector.service";
import { take } from "rxjs/operators";
import { PaymentMethodLookUp } from "../../../model/payment.lookup";
import { DialogType } from "projects/sepidz-web-framework/src/lib/models/dialog.enum";
import { WebKind } from "projects/sepidz-web-framework/src/lib/models/enums";

@Component({
  selector: "order-delino-offlinefactor",
  templateUrl: "./delinoofflinefactor.component.html",
  styleUrls: ["./delinoofflinefactor.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DelinoOfflineFactorcomponent extends BaseFormComponent<any> {
  public PaymentTypeData: PaymentMethodLookUp[] = [];

  constructor(protected selectorService: SelectorService, protected cd: ChangeDetectorRef, public order: OrderService) {
    super(selectorService, cd);
  }

  async ngOnInit() {
    this.apiName = "";
    this.label = "";
    this.areaName = "";
    this.setValue("WebId", null);
    this.setValue("DelinoPaymentMethod", "");
    const invoice = this.order.invoice;
    if (invoice.WebId) this.setValue("WebId", `${invoice.WebId}`);
    if (invoice.PaymentMethodTypeId) this.setValue("DelinoPaymentMethod", `${invoice.PaymentMethodTypeId}`);
    this.fillPaymentMethodType();
  }

  fillPaymentMethodType() {
    this.httpCommonService
      .getList("PaymentMethod/PaymentMethodLookUp" + "/" + this.order.logInBranch.Id)
      .pipe(take(1))
      .subscribe((data: PaymentMethodLookUp[]) => {
        this.PaymentTypeData = data;
        const paymentTypeId = this.order.invoice.PaymentMethodTypeId ?? this.order.currentBranch?.PaymentType;
        this.setValue("DelinoPaymentMethod", paymentTypeId);
        this.cd.markForCheck();
        this.order.detectChanges();
      });
  }

  public SaveDelinoFactor(): void {
    this.order.invoice.WebId = Number(this.formGroup.controls["WebId"].value);
    this.order.invoice.WebKindId = this.order.WebKinds.find(x=>x.Code ==  WebKind.Delino)?.Id;
    this.order.invoice.PaymentMethodTypeId = Number(this.formGroup.controls["DelinoPaymentMethod"].value);
    this.order._opened = false;
  }

  public onDelinoPaymentMethodChanges(): void {
    this.order.shouldCloseSidebar = false;
  }
}
